import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAiU0bLupbMcrX7Mfyo6_zwauCyTtEE3CA",
  authDomain: "arrnode-landing.firebaseapp.com",
  projectId: "arrnode-landing",
  storageBucket: "arrnode-landing.firebasestorage.app",
  messagingSenderId: "485587439461",
  appId: "1:485587439461:web:941cef2eb0484c2eee9b8c",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
